import React, { Component } from "react";
import api from "../../config/api";
import { withStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core/";
import { Link } from "react-router-dom";
import { amountDueComp, checkAllVincendoComp, setExpirationDay } from "../../actions"
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import logoPagueFacil from "../../assets/img/logo-pague-facil.svg";
import LoadingDefault from "../LoadingDefault";

const styles = theme => ({
  //Box azul com informações do usuário
  userInfo: {
    display: "flex",
    justifyContent: "space-between",
    background: "#1874B9",
    color: "#fff",
    marginTop: 36,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    },
    flexGrow: 1,
    position: 'fixed',
    top: 0,
    width: '100%',
    height: '100px',
    zIndex: 9,
  },
  welcomeUser: {
    padding: "10px 15px",
    display: "flex",
    alignItems: "center"
  },
  linkToHome: {
    textDecoration: "none",
    color: "inherit"
  },
  logoPagueFacil: {
    width: 100
  },
  messageTouser: {
    fontSize: 20,
    marginLeft: 30,
    maxWidth: '35ch',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    transition: 'all .2s',
    "&:hover": {
      transform: "scale(1.05)",
    }
  },

  userDebits: {
    display: "flex",
    alignItems: "center"
  },
  userDebitsItem: {
    padding: 20
  },
  userDebitsTitle: {
    margin: 0,
    fontSize: 26
  },
  userDebitsText: {
    margin: 0,
    fontSize: 15
  },
  clickableDivVincendo: {
    cursor: 'pointer',
    transition: 'all .2s',
    "&:hover": {
      transform: 'scale(1.05)',
    }
  },
  customWidth:{
    marginTop: -120,
    maxWidth: 300
  }
});

function handleGetShift() {
  const currentDate = new Date();
  const hour = currentDate.getHours();

  if (hour >= 0 && hour <= 4) {
    return "Boa madrugada";
  }
  if (hour >= 5 && hour <= 11) {
    return "Bom dia";
  } else if (hour >= 12 && hour <= 17) {
    return "Boa tarde";
  } else if ((hour >= 18 && hour <= 23) || hour === 0) {
    return "Boa noite";
  }
}

class HeaderUser extends Component {
  constructor(props) {
    super(props);
    this.getAmountDebitsHeader = this.getAmountDebitsHeader.bind(this);

    this.state = {
      slide: 0,
      amountDue: 0,
      percentageDue: 0,
      amountLoading: false,
      amountError: false,
      userName: props.represented?.name
    };
  }

  componentDidMount() {
    this.getAmountDebitsHeader();
    this.props.checkAllVincendoComp(false)
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.handleScroll);
  };

  async getAmountDebitsHeader() {

    if (this.props.amountDueValue === -1) {
      this.setState({
        amountLoading: true,
      });

      try {
        let amountDue = await api.get("Debitos/ObterValorAVencer");
        this.setState({
          amountDue: amountDue.data.Valor.toFixed(2)
            .replace(".", ",")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."),
          amountLoading: false
        }, () => {
          this.props.amountDueComp(amountDue.data.Valor.toFixed(2)
            .replace(".", ",")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."))
        });

        this.props.setExpirationDay(amountDue.data.Dias);
      } catch (error) {
        this.setState({
          amountLoading: false,
          amountError: true
        });
      }
    }
  }

  handleScroll = () => {
    const { lastScrollY } = this.state;
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY) {
      this.setState({ slide: "-20px" });
    } else {
      this.setState({ slide: "0px" });
    }
    this.setState({ lastScrollY: currentScrollY });
  };

  handleCheckAllVincendo = () => {
    this.props.checkAllVincendoComp(!this.props.checkAllVincendoValue)
  };

  render() {
    const messageDay = handleGetShift();
    const {
      userName,
      amountLoading,
      amountError,
    } = this.state;
    const { classes } = this.props;

    let userS = userName?.toLowerCase()
    const name = userS?.replace(/\b[a-z]/g, match => match.toUpperCase())


    return (
      <div
        className={classes.userInfo}
        onScroll={this.handleScroll}
      // style={{
      //   transform: `translate(0, ${slide})`,
      //   transition: "transform 0.4s linear"
      // }}
      >
        <Link to="/" className={classes.linkToHome}>
          <div className={classes.welcomeUser}>
            <img
              src={logoPagueFacil}
              className={classes.logoPagueFacil}
              alt="Logo PagueFácil"
            />
            <Tooltip title={name} classes={{ tooltip: classes.customWidth }} arrow>
              <p className={classes.messageTouser}><span>{messageDay}, </span> {name}!</p>
            </Tooltip>
          </div>
        </Link>

        <div className={classes.userDebits}>
          <div
            className={classes.userDebitsItem}
          >
            {amountLoading && (
              <div className={classes.loadingDiv}>
                <LoadingDefault typeLoading={"header"} />
              </div>
            )}

            {!amountLoading &&
              <div>
                {!amountError ? (
                  <div onClick={this.handleCheckAllVincendo} className={classes.clickableDivVincendo}>
                    <p className={classes.userDebitsTitle}>
                      {" "} R$ {this.props.amountDueValue}
                    </p>
                    <p className={classes.userDebitsText}>
                      {" "} Vencem nos próximos {this.props.dateExpiration} dias
                    </p>
                  </div>
                ) : (
                    <p>Erro ao carregar dados.</p>
                  )}
              </div>
            }

          </div>
        </div>
      </div>
    );
  }
}

// export default withStyles(styles, { withTheme: true })(HeaderUser);
const mapStateToProps = (store) => ({
  amountDueValue: store.cardDebitState.amountDueValue,
  checkAllVincendoValue: store.cardDebitState.checkAllVincendoValue,
  dateExpiration: store.cardDebitState.dateExpiration,
  represented: store.auth.represented
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    amountDueComp,
    checkAllVincendoComp,
    setExpirationDay
  }, dispatch);

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(HeaderUser)
);
